module.exports = __webpack_public_path__ + "img/cocos_5.be574582.jpg";